import { useParams, Navigate } from 'react-router-dom';

const LEGACY_SPREAD_MAP = {
  single: 'breath',
  three: 'theme',
  celtic: 'deep',
};

export function LegacySpreadRedirect() {
  const { id } = useParams();
  const target = LEGACY_SPREAD_MAP[id] || id || 'breath';
  return <Navigate to={`/meditation/${target}`} replace />;
}
